"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashboardTasksQueryState = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const getDashboardTasksQueryState = ({ catalogId, filter, pageSize, projectId, sort, }) => ({
    [view_query_params_1.ViewQueryStateField.ProjectId]: projectId,
    [view_query_params_1.ViewQueryStateField.CatalogId]: catalogId,
    [view_query_params_1.ViewQueryStateField.Filter]: filter,
    [view_query_params_1.ViewQueryStateField.Sort]: sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: pageSize,
});
exports.getDashboardTasksQueryState = getDashboardTasksQueryState;
